// Apply at display time so saved jobs and in-flight worker messages are covered.
export function customerText(value = "") {
  return String(value)
    .replace(/\bgpt-[\w.-]+\b/gi, "Trace")
    .replace(/\bAstra\b/gi, "Trace")
    .replace(/\s*\((?:Read|Connect)?Timeout\)/gi, "");
}
